import { CustomerService } from "../common/api.service";

const initialState = {};

const state = { ...initialState };

const getters = {};

const mutations = {};

const actions = {
  findCustomers(_, params) {
    return CustomerService.find(params).then(({ data }) => data);
  },
  getCustomer(_, id) {
    return CustomerService.get(id).then(({ data }) => data);
  },
  saveCustomer(_, {
    id, date, reseller, retailer, ccode, ...body
  }) {
    const request = id
      ? CustomerService.update(id, body)
      : CustomerService.create(body);

    return request.then(({ data }) => data);
  },
  deleteCustomer(_, id) {
    return CustomerService.delete(id).then(({ data }) => data);
  },
  findResellerCustomers(_, params) {
    return CustomerService.findResellerCustomers(params).then(({ data }) => data);
  },
  saveResellerCustomer(_, {
    id, date, retailer, ccode, ...body
  }) {
    const request = id
      ? CustomerService.updateResellerCustomer(id, body)
      : CustomerService.createResellerCustomer(body);

    return request.then(({ data }) => data);
  },
  deleteResellerCustomer(_, id) {
    return CustomerService.deleteResellerCustomer(id).then(({ data }) => data);
  },
  findRetailerCustomers(_, params) {
    return CustomerService.findRetailerCustomers(params).then(({ data }) => data);
  },
  saveRetailerCustomer(_, {
    id, date, ccode, ...body
  }) {
    const request = id
      ? CustomerService.updateRetailerCustomer(id, body)
      : CustomerService.createRetailerCustomer(body);

    return request.then(({ data }) => data);
  },
  deleteRetailerCustomer(_, id) {
    return CustomerService.deleteRetailerCustomer(id).then(({ data }) => data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
